import { render, staticRenderFns } from "./VTemplateDocuments.vue?vue&type=template&id=2e261110&scoped=true&lang=pug"
import script from "./VTemplateDocuments.vue?vue&type=script&lang=ts"
export * from "./VTemplateDocuments.vue?vue&type=script&lang=ts"
import style0 from "./VTemplateDocuments.vue?vue&type=style&index=0&id=2e261110&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e261110",
  null
  
)

export default component.exports